import type {ReactElement} from 'react';
import React from 'react';
import styles from './quality-item.module.scss';
import {Text, TextSize} from '@Components/text';
import {Tag} from '@Components/tag';
import {DesignQualityType} from '@Components/download-panel/components/quality-item/quality-item.types';

interface QualityItemProps {
  id: string;
  text: string;
  tagText?: string;
  isSelected?: boolean;
  durationLimit?: number;
  type?: DesignQualityType;
  onClick: (id: string) => void;
}

export function QualityItem({tagText = '', type = DesignQualityType.BASIC, isSelected = false, ...props}: QualityItemProps): ReactElement {
  return (
    <li
      onClick={(): void => {
        if (isSelected) {
          return;
        }
        props.onClick(props.id);
      }}
      id={props.id}
      className={`${styles.container} ${isSelected ? styles.selected : ''} flex flex-v-row radius-8 hover-transition-all`}
    >
      <div className={`flex-row-justify-between flex-items-center`}>
        <Text bold val={props.text} size={TextSize.XSMALL} className={isSelected ? 'content-primary' : 'content-body'} />
        {tagText ? <Tag className="radius-round" text={tagText} /> : null}
      </div>
      {/*<Text size={TextSize.XXSMALL} val={window.i18next.t('pmwjs_watermark')} className="content-primary" />*/}
      {/*{props.durationLimit ? <Text size={TextSize.XXSMALL} val={window.i18next.t('pmwjs_duration_limit', {limit: props.durationLimit})} className="content-primary" /> : null}*/}
    </li>
  );
}
